import template from './idSmartSummary.template.html';

export default {
  template,
  bindings: {
    contact: '<',
    onFinish: '&'
  },
controller: class controller {
    constructor($mdDialog) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = () => {};

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
